
export const auth = {
	namespaced: true,
	state: {user: JSON.parse(localStorage.getItem('user')),
	language: localStorage.getItem('language')
	},
}